<template>
  <div>
    <Head :title="title" />
    <div class="mb-6 flex justify-between items-center">
      <search-input v-model="form.search" class="w-full max-w-md mr-4" @reset="reset"></search-input>
      <Link class="btn-indigo" :href="route('classifications.create')">
        <span>{{ __('Create New') }}</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4"></th>
          <th class="px-6 pt-6 pb-4">Nombre</th>
          <th class="px-6 pt-6 pb-4">Subclasificaciones</th>
        </tr>
        <tr v-for="classification in classifications.data" :key="classification.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t w-px">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('classifications.edit', classification.id)">
              <icon v-if="classification.icon" :name="classification.icon" class="w-6 h-6 fill-gray-500" />
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('classifications.edit', classification.id)">
              {{ classification.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('classifications.edit', classification.id)">
              {{ classification.subclassifications_count }}
            </Link>
          </td>
          <td class="border-t w-px">
            <Link class="px-4 flex items-center" :href="route('classifications.edit', classification.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="classifications.data.length === 0">
          <td class="border-t px-6 py-4" colspan="3">No se encontraron clasificaciones.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="classifications.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import { Link, Head } from '@inertiajs/inertia-vue3'

export default {
  metaInfo: { title: 'Clasificaciones' },
  components: {
    SearchInput,
    Icon,
    Pagination,
    Link,
    Head,
  },
  layout: Layout,
  props: {
    title: String,
    filters: Object,
    classifications: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('classifications'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
